var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"pro-switch",class:{ 'pro-switch--large': _vm.large },attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}})}
var staticRenderFns = []

export { render, staticRenderFns }